import { Reference } from 'types/reference';
import { FooterMenuLabel } from './FooterMenuLabel';
import Link from 'components/gruenland/atoms/link';
import classNames from 'classnames';

export interface FooterLink {
  name: string;
  reference: Reference;
}

export interface Props {
  header?: string;
  links: FooterLink[];
  className?: string;
}

const Column1: React.FC<Props> = ({ header, links, className }) => {
  return (
    <div className={classNames('flex flex-col gap-4', className)}>
      {header && <FooterMenuLabel>{header}</FooterMenuLabel>}
      <ul role="list" className="contents">
        {links.map((item, i) => (
          <li key={i}>
            <Link variant="footer" link={item.reference}>
              {item.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Column1;
